<template>
  <section class="auth">
    <form class="auth__card" @submit.prevent="login()">
      <h1 class="auth__title">Login</h1>

      <b-field label="Email">
        <b-input v-model.trim="email" type="email" placeholder="Your email" autocomplete="email" required></b-input>
      </b-field>

      <b-field label="Password">
        <b-input v-model="password" type="password" placeholder="Your password" autocomplete="current-password" password-reveal required></b-input>
      </b-field>

      <button type="submit" class="tb-btn" :disabled="loading">
        {{ loading ? "Signing in..." : "Login" }}
      </button>

      <router-link class="auth__link" to="/forgot">Forgot password?</router-link>
    </form>
  </section>
</template>

<script>
  export default {
    name: "Login",
    data() {
      return {
        email: "",
        password: "",
        loading: false
      };
    },
    methods: {
      async login() {
        if (!this.email || !this.password) return;
        this.loading = true;
        try {
          await this.$store.dispatch("login", { email: this.email, password: this.password });
          this.$router.push("/admin");
        } catch (error) {
          this.$buefy.toast.open({ message: error.message, type: "is-danger" });
        } finally {
          this.loading = false;
        }
      }
    }
  };
</script>

<style scoped>
  .auth {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 24px 16px calc(24px + env(safe-area-inset-bottom, 0px));
    background: #1f2430;
  }

  .auth__card {
    width: 100%;
    max-width: 380px;
    padding: 22px;
    border-radius: var(--tb-radius);
    background: var(--tb-surface);
    box-shadow: var(--tb-shadow-lg);
    text-align: left;
  }

  .auth__title {
    margin: 0 0 18px;
    font-size: 22px;
  }

  .auth__card .tb-btn {
    margin-top: 18px;
  }

  .auth__link {
    display: block;
    margin-top: 14px;
    font-size: 13px;
    text-align: center;
  }
</style>
